import { render, staticRenderFns } from "./galleryOnlineGoods.vue?vue&type=template&id=5364233f&scoped=true&"
import script from "./galleryOnlineGoods.vue?vue&type=script&lang=js&"
export * from "./galleryOnlineGoods.vue?vue&type=script&lang=js&"
import style0 from "./galleryOnlineGoods.vue?vue&type=style&index=0&id=5364233f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364233f",
  null
  
)

export default component.exports